import { render, staticRenderFns } from "./BaseLocationsState.vue?vue&type=template&id=96b61a6a&scoped=true&"
import script from "./BaseLocationsState.vue?vue&type=script&lang=js&"
export * from "./BaseLocationsState.vue?vue&type=script&lang=js&"
import style0 from "./BaseLocationsState.vue?vue&type=style&index=0&id=96b61a6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b61a6a",
  null
  
)

export default component.exports